export enum QR_STEPS {
    QR_STEP_1 = 'QR_STEP_1',
    QR_STEP_2 = 'QR_STEP_2',
}
